import React, { useState } from 'react'
import "./style.css"
import ModalComponent from '../Modal'
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
interface ViewDocUploadedProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  document: any;

}
const ViewDocUploaded: React.FC<ViewDocUploadedProps> = ({ show, setShow }) => {
  const [file, setFle] = useState<any[]>([]);
  const onFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    console.log(newFiles)
    setFle([{ uri: window.URL.createObjectURL(newFiles[0]),
      fileName: newFiles[0].name}])
    //setFle([{uri:"https://cdn.prod.website-files.com/603d0d2db8ec32ba7d44fffe/603d0e327eb2748c8ab1053f_loremipsum.pdf"}])
    console.log(`${(URL.createObjectURL(newFiles[0])).split('blob:')[1]}.txt`)
  }

  const onCloseModal = () => {
    setFle([]);
    setShow(false);
  }
  return (
    <ModalComponent type='plain' title='View Documnet' size='xl' show={show} setShow={onCloseModal} enableFooter={false}>
      <div>
      <input
        type="file"
        onChange={onFileUpload}
        multiple
        style={{
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",

        }}
      />
      </div>

      {file && <DocViewer documents={file} pluginRenderers={DocViewerRenderers} />}
    </ModalComponent>
  )
}

export default ViewDocUploaded